import React from 'react'

export default class ImageLoader extends React.Component {
  render() {
    return (
        <div className="image-loader">
          <i className="fas fa-circle-notch fa-spin"></i>
        </div>
    )
  }
}